import _objectSpread from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import simpleCheckbox from '@/gikam/js/components/template/fields/simpleCheckbox.vue';
import { mapState } from 'vuex';
import Gikam from 'gikam';
export default {
  props: {
    options: Object,
    propValue: String,
    validateArg: Object,
    formData: Object,
    dataId: [Number, String]
  },
  components: {
    simpleCheckbox: simpleCheckbox
  },
  data: function data() {
    var _this$options$readonl;

    return {
      readonly: (_this$options$readonl = this.options.readonly) !== null && _this$options$readonl !== void 0 ? _this$options$readonl : false
    };
  },
  computed: _objectSpread({}, mapState(['form'])),
  mounted: function mounted() {
    this.form.editorManager[this.options.field] = this.$refs.editor;
  },
  methods: {
    changeHandle: function changeHandle() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['change'].concat(args));
    },
    dataChangeHandle: function dataChangeHandle() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['dataChange'].concat(args));
    },
    beforeChangeHandle: function beforeChangeHandle() {
      var _this$options$onBefor;

      return (_this$options$onBefor = this.options.onBeforeChange) === null || _this$options$onBefor === void 0 ? void 0 : _this$options$onBefor.call(this.form, Gikam.deepExtend(this.formData));
    }
  }
};